import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import logo from './img/logo.png';
import '../reset.css';
const Div_no =styled.div`
width : 158.86px; 
opacity : 0%;
`
const Div = styled.div`
width : 158.86px; 
background : white;
opacity : 70%;

`
const UL = styled.ul`
    padding : 0 15px;
`
const LI = styled.li`
    text-align : left;
    & a:hover{
        font-weight : bold;
    }
`
function Category1({state,func}){
    if(state == true)
    {
    return (
        <Div onMouseLeave={()=>{func(false)}}>
            <UL>
                <LI><a href="/Research/super_GUC">SUPER GUC</a></LI>
                <LI><a href="/Research/SNUG_DB">SNUG DB</a></LI>
                <LI><a href="/Research/multicenter_studies">Multicenter Studies</a></LI>
                <LI><a href="/Research/ai_research">AI Research</a></LI>
            </UL>
        </Div>
    )
    }
    else{
        return(<Div_no></Div_no>)
    }
}
function Category2({state,func}){
    if(state == true)
    {
    return (
        <Div onMouseLeave={()=>{func(false)}}>

        </Div>
    )
    }
    else{
        return(<Div_no></Div_no>)
    }
}
function Category3({state,func}){
    if(state == true){
    return (
        <Div onMouseLeave={()=>{func(false)}}>
            <UL>
                <LI><a href="/Resources/NIA_AI">Example of AI model</a></LI>
                <LI><a href="/Resources/KUOS">KUOS</a></LI>
                <LI><a href="/Resources/Resources">Resources And Links</a></LI>
            </UL>
        </Div>
    )
    }
    else{
        return(<Div_no></Div_no>)
    }
}
function Category4({state,func}){
    if(state == true){
    return (
        <Div onMouseLeave={()=>{func(false)}}>

        </Div>
    )
    }
    else{
        return(<Div_no></Div_no>)
    }
}
function Nav(){
    const [category1, category1_set]= useState(false);
    const [category2, category2_set]= useState(false);
    const [category3, category3_set]= useState(false);
    const [category4, category4_set]= useState(false);

    return (
        <div>
        <Nav_Wrapper>
        <Nav_ul>
        <a href="/"><Logo_span></Logo_span></a>
            <Nav_li onMouseOver={()=>{category1_set(true);category2_set(false);category3_set(false);category4_set(false);}}>
            ㅤResearch
            </Nav_li>
            <Nav_li onMouseOver={()=>{category2_set(true);category1_set(false);category3_set(false);category4_set(false);}}>
            ㅤ<A href="/People">People</A>
            </Nav_li>
            <Nav_li onMouseOver={()=>{category4_set(true);category1_set(false);category2_set(false);category3_set(false);}}>
            <LI><A href="/publications/selected_publications">Publications</A></LI>
            </Nav_li>
            <Nav_li onMouseOver={()=>{category3_set(true);category1_set(false);category2_set(false);category4_set(false);}}>
            ㅤResources
            </Nav_li>
        </Nav_ul>
        </Nav_Wrapper>
        <Nav_Wrapper>
        <Nav_ul>
            <Nav_li><Category1 state={category1} func={category1_set}/></Nav_li>
            <Nav_li><Category2 state={category2} func={category2_set}/></Nav_li>
            <Nav_li><Category4 state={category4} func={category4_set}/></Nav_li>
            <Nav_li><Category3 state={category3} func={category3_set}/></Nav_li>
        </Nav_ul>
        </Nav_Wrapper>
        </div>
)
}  

const Nav_Wrapper = styled.nav`
font-family: "nav_top_Ligth";        
position: fixed;
left : 0; 
right : 0; 
margin : 0 auto;
height : 90px; 
z-index : 10;
width : 1200px;
background: white;
&:nth-child(2){
    background: none;
    top : 90px;
    & ul li {
        padding : 0;
    }
}
&:nth-child(2){
      & div:nth-child(1){
          width : 230px;
          & ul li a:hover{
            color: #32A4FF;   
          }
      }
  }
`  
const Logo_span = styled.span`
  width : 255px;
  height : 90px; 
  position : absolute; 
  left : 50px; 
  display : inline-block;
  background-image : url(${logo});
  background-size : 249.375px 90px;
`
const Nav_ul = styled.ul`
  position : relative;
  right : 0px;
  margin : 0; 
  height : 90px; 
  min-width : 700px;
  text-align : right;


`
const Nav_li = styled.li`
    width : 160px;
    text-align : left;
    padding : 20px 0px; 
    display : inline-block;
    line-height:40px;
    font-size : 20px;
    color : #414141;
    font-weight : bold;

    &:hover{
      color : #32A4FF;
    
    }
    `
const A = styled.a`
&:hover{
    color : #32A4FF;
  }`
export default Nav;